<template>
  <section test_id="experience-section">
    <Card>
      <div>
        <div class="tw-mb-4 tw-flex tw-items-center tw-justify-between">
          <h2 class="tw-heading-2">Experience</h2>
          <AddExperience v-if="isEditModeEnabled" />
        </div>
        <div class="tw-flex tw-flex-col tw-space-y-4">
          <ExperienceElement
            v-for="work in experience"
            :key="work.id"
            :work="work"
          />
        </div>
      </div>
    </Card>
  </section>
</template>

<script setup>
import Card from '@/shared/components/Card.vue'
import ExperienceElement from './ExperienceElement.vue'
import AddExperience from './AddExperience.vue'
import { useEditProfileModeInjector } from '@/shared/composables/edit-profile-mode/useEditProfileModeInjector.js'

defineProps({
  experience: {
    type: Array,
    required: true,
  },
})

const { isEditModeEnabled } = useEditProfileModeInjector()
</script>
